import React, { Fragment, useEffect, useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Backdrop, Box, Button, Fade, FormControlLabel, Modal, Paper, Radio, RadioGroup, Typography } from '@mui/material';
import styles from './MenuDropdown.module.scss';
import { IMenuSchedule } from '../../pages/home/models/menuItemModels';

export interface IMenuDropdownProps {
	options: IMenuSchedule[] | undefined;
	changeSchedule: (scheduleName: string, scheduleStartTime: string, scheduleEndTime: string) => void;
	menuName: string;
	menuStartTime: string;
	menuEndTime: string;
}

const MenuDropdown: React.FC<IMenuDropdownProps> = (props: IMenuDropdownProps) => {
	const [selectedMenu, setSelectedMenu] = useState<string>(props.menuName);
	const [selectedMenuStartTime, setSelectedMenuStartTime] = useState<string>(props.menuStartTime);
	const [selectedMenuEndTime, setSelectedMenuEndTime] = useState<string>(props.menuEndTime);
	const [isModalOpen, setIsModalOpen] = useState(false);

	useEffect(() => {
		setSelectedMenu(props.menuName);
		setSelectedMenuStartTime(props.menuStartTime);
		setSelectedMenuEndTime(props.menuEndTime);
	}, [props.menuEndTime, props.menuName, props.menuStartTime, isModalOpen]);
	
	const handleClose = () => setIsModalOpen(false);

	const handleMenuChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const selected = props.options?.find(opt => opt.name === event.target.value);
		if (selected) {
			setSelectedMenu(selected.name);
			setSelectedMenuStartTime(selected.startTime);
			setSelectedMenuEndTime(selected.endTime);
		}
	};

	const handleMenuClick = (schedule: IMenuSchedule) => {
		setSelectedMenu(schedule.name);
		setSelectedMenuStartTime(schedule.startTime);
		setSelectedMenuEndTime(schedule.endTime);
	};
	

	return (
		<>
			<button
				className={styles.menuText}
				onClick={() => {
					setIsModalOpen(true);
				}}
			>
				<span className={styles.dropDownScheduleName}>
					{props.menuName.length > 18 ? `${props.menuName.slice(0, 18)}...` : props.menuName}
				</span>
				<span className={styles.dropdownScheduleTime}>
					{`${props.menuStartTime} - ${props.menuEndTime}`}
				</span>
				<ExpandMoreIcon className={styles.scheduleArrow}/>
			</button>

			<Modal
				open={isModalOpen}
				onClose={handleClose}
				closeAfterTransition
				slots={{ backdrop: Backdrop }}
				slotProps={{
					backdrop: {
						className: styles.customBackdrop,
						timeout: 300,
					},
				}}
			>
				<Fade in={isModalOpen}>
					<Box className={styles.menuBox}>
						<Box className={styles.paddingDiv}>
							<Box className={styles.textcenter}>
								<Button className={styles.draggablebtn}></Button>
							</Box>

							<RadioGroup
								aria-labelledby="demo-radio-buttons-group-label"
								name="radio-buttons-group"
								value={selectedMenu}
								onChange={handleMenuChange}
							>
								{props?.options?.map((schedule, index) => (
									<Fragment key={index}>
										<Paper
											className={styles.Menupaper}
											elevation={0}
											onClick={() => handleMenuClick(schedule)}
										>
											<Box className={styles.radiodiv}>
												<FormControlLabel
													value={schedule.name}
													control={<Radio />}
													label={schedule.name}
													className={styles.schedulename}
												/>
												<Typography>
													{schedule.startTime} - {schedule.endTime}
												</Typography>
											</Box>
										</Paper>
									</Fragment>
								))}
							</RadioGroup>
						</Box>

						<Box className={styles.btndiv}>
							<Button
								className={styles.confirmbtn}
								onClick={() => {
								handleClose();
									props.changeSchedule(selectedMenu, selectedMenuStartTime, selectedMenuEndTime);
								}}
							>
								Confirm
							</Button>
						</Box>
					</Box>
				</Fade>

			</Modal>
		</>
	);
};
export default MenuDropdown;
